import React, { useState } from "react";
import { FaGithubSquare } from "react-icons/fa";
import { SiNetlify } from "react-icons/si";
const Card = (props) => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  if (modal) {
    document.body.classList.add("active-modal");
  } else {
    document.body.classList.remove("active-modal");
  }
  return (
    <>
      <div className="box btn_shadow " style={{margin:"10px"}}>
        <div className="img">
          <img
            src={props.image}
            alt=""
            onClick={toggleModal}
            style={{ width: "100%" }}
          />
        </div>
        <div className="category d_flex">
          <p onClick={toggleModal}>{props.category}</p>
          <div
            style={{
              width: "150px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <a href={props.netlify} style={{ color: "royalblue" }} target="_blank" rel="noopener noreferrer">
              <SiNetlify fontSize={50} />
            </a>
            <a
              href={props.github}
              style={{ fontSize: "20px", fontWeight: "bold" }} target="_blank" rel="noopener noreferrer"
            >
              <FaGithubSquare fontSize={50} />
            </a>
          </div>
        </div>
        <div className="title">
          <h2 onClick={toggleModal}>{props.title}</h2>
          <a href="#popup" className="arrow" onClick={toggleModal}>
            <i className="fas fa-arrow-right">
              {" "}
            </i>   
          </a>
          <p onClick={toggleModal}>{props.about}</p>
        </div>
      </div>

      {/* Popup box */}
      {modal && (
        <div className="modal">
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modal-content d_flex">
            <div className="modal-img">
              <img src={props.image} alt="" />
            </div>
            <div className="modal-text right">
              <span>{props.category}</span>
              <h1 onClick={toggleModal}>{props.title}</h1>
              <p>{props.info}</p>
              <button className="close-modal btn_shadow" onClick={toggleModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Card;
